import { Skeleton } from "@/components/kit";
import type { CustomerProfileProductAffinityResultDTO } from "@/modules/customers/domain/types";
import { formatLak } from "@/shared/lib/currency";
import { formatDateTimeLocal } from "@/shared/lib/date-time";

type CustomerProductAffinityCardProps = {
  result?: CustomerProfileProductAffinityResultDTO;
  isLoading?: boolean;
};

export function CustomerProductAffinityCard({
  result,
  isLoading,
}: CustomerProductAffinityCardProps) {
  if (isLoading) {
    return <Skeleton className="h-36 w-full rounded-2xl" />;
  }

  const rows = result?.data ?? [];
  if (rows.length === 0) {
    return null;
  }

  return (
    <section className="brand-card flex flex-col gap-3 p-4">
      <div>
        <h3 className="font-display text-lg">ສິນຄ້າທີ່ຊື້ເລືອຍ</h3>
        <p className="text-muted-foreground text-sm">
          Top {rows.length} ຈາກອໍເດີ້ຢືນຢັນ — ບໍ່ລວມຂອງແຖມ
        </p>
      </div>

      <ul className="flex flex-col gap-2">
        {rows.map((row) => (
          <li
            key={row.variantId}
            className="flex flex-wrap items-start justify-between gap-2 rounded-xl border border-border/60 px-3 py-2.5"
          >
            <div className="min-w-0">
              <p className="font-medium">{row.productName}</p>
              {row.variantName ? (
                <p className="text-muted-foreground text-xs">{row.variantName}</p>
              ) : null}
              <p className="mt-1 text-muted-foreground text-xs">
                {row.orderCount} ອໍເດີ້ · {row.quantity} {row.stockUnitLabel}
                {row.lastOrderedAt
                  ? ` · ລ່າສຸດ ${formatDateTimeLocal(row.lastOrderedAt)}`
                  : null}
              </p>
            </div>
            <span className="font-medium tabular-nums">{formatLak(row.revenue)}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
